var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMapsTrafficScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.google{fill:url(#google-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aaceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36069,
    stopColor: "#5998f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#3c85f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3369cb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "google",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M50,76.61328c.82812,0,1.5-.67188,1.5-1.5v-9.69897h3.1181c2.43463,0,4.40826-1.97369,4.40826-4.40833v-31.71082c0-2.43463-1.97363-4.40833-4.40826-4.40833h-9.23621c-2.43463,0-4.40826,1.97369-4.40826,4.40833v31.71082c0,2.43463,1.97363,4.40833,4.40826,4.40833h3.1181v9.69897c0,.82812.67188,1.5,1.5,1.5ZM50,29.31036c2.19952,0,3.9826,1.78308,3.9826,3.9826s-1.78308,3.9826-3.9826,3.9826-3.9826-1.78308-3.9826-3.9826,1.78308-3.9826,3.9826-3.9826ZM50,41.01593c2.19952,0,3.9826,1.78308,3.9826,3.9826s-1.78308,3.98254-3.9826,3.98254-3.9826-1.78302-3.9826-3.98254,1.78308-3.9826,3.9826-3.9826ZM46.0174,56.70404c0-2.19952,1.78308-3.9826,3.9826-3.9826s3.9826,1.78308,3.9826,3.9826-1.78308,3.9826-3.9826,3.9826-3.9826-1.78308-3.9826-3.9826Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M68.55078,43.65039h-4.0293c-.82812,0-1.5.67139-1.5,1.5s.67188,1.5,1.5,1.5h4.0293c.82812,0,1.5-.67139,1.5-1.5s-.67188-1.5-1.5-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M64.52246,41.17285c.21973,0,.44336-.04883.6543-.15137l3.625-1.76025c.74512-.36182,1.05566-1.25928.69434-2.00439-.3623-.74414-1.25781-1.05518-2.00488-.69385l-3.625,1.76025c-.74512.36182-1.05566,1.25928-.69434,2.00439.25977.53418.79395.84521,1.35059.84521Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M68.80176,51.03906l-3.625-1.75977c-.74609-.35986-1.64258-.05078-2.00488.69434-.36133.74561-.05078,1.64258.69434,2.00488l3.625,1.75977c.21094.10254.43457.15039.6543.15039.55664,0,1.09082-.31055,1.35059-.84473.36133-.74512.05078-1.64258-.69434-2.00488Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M35.47852,43.65039h-4.0293c-.82812,0-1.5.67139-1.5,1.5s.67188,1.5,1.5,1.5h4.0293c.82812,0,1.5-.67139,1.5-1.5s-.67188-1.5-1.5-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M31.19824,39.26123l3.625,1.76025c.21094.10254.43457.15137.6543.15137.55664,0,1.09082-.31104,1.35059-.84521.36133-.74512.05078-1.64258-.69434-2.00439l-3.625-1.76025c-.74512-.3623-1.64258-.05127-2.00488.69385-.36133.74512-.05078,1.64258.69434,2.00439Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M34.82324,49.2793l-3.625,1.75977c-.74512.3623-1.05566,1.25977-.69434,2.00488.25977.53418.79395.84473,1.35059.84473.21973,0,.44336-.04785.6543-.15039l3.625-1.75977c.74512-.3623,1.05566-1.25928.69434-2.00488-.3623-.74512-1.25781-1.05322-2.00488-.69434Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMapsTrafficScraper);
export default __webpack_public_path__ + "static/media/google-maps-traffic-scraper.befde7a7033691b0bb2141d14520a87f.svg";
export { ForwardRef as ReactComponent };